import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isArray from 'lodash/isArray';

import { formatPrice as format } from 'utils/formatters';

export default function createPriceRange(priceRange = [], currency = '') {
  const isValid = _isArray(priceRange) && !_isEmpty(priceRange);

  if (!isValid) return '';

  const minPrice = _get(priceRange, 0, '');
  const maxPrice = _get(priceRange, 1, '');

  return `${format(minPrice, currency)} - ${format(maxPrice, currency)}`;
}
